<template>
    <div class="plateorder">

        <div class="width_100" style="margin-top: 28px">
            <el-table :data="dataList" style="width: 100%" :header-cell-style="headercellstyle" border height="70vh"
                :key="'taobaoTable'">
                <el-table-column prop="goodsid" label="商品ID" align="center"></el-table-column>
                <el-table-column prop="goodsname" label="商品名称" align="center"></el-table-column>
                <el-table-column prop="type" label="渠道" align="center">
                    <template slot-scope="scope">
                        {{
                            scope.row.type == "1"
                                ? "淘宝"
                                : scope.row.type == "2"
                                    ? "京东"
                        : "拼多多"
                        }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="店铺" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.shopinfo.name }}
                    </template></el-table-column>
                <el-table-column prop="operation" label="运营责权人" align="center">
                    <template slot-scope="scope">
                        <div class="costduty-operation" style="">
                            <el-select @change="seleUser(scope.row)" v-model="scope.row.zqname" placeholder="请选择"
                                style="font-size: 12px">
                                <el-option v-for="item in userlist" :key="item.id" :label="item.nickname"
                                    :value="item.id"></el-option>
                            </el-select>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" @click="eventClick(scope.row)">责权记录</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
            @pagination="getHetongListFun" />

        <el-drawer title="责权记录" :visible.sync="strokeDrawer" :show-close="true" size="44%">
            <div ref="scrollContainer" style="max-height: 88vh; overflow-y: auto">
                <div class="revenbook-drawer vue_flex vue_column">
                    <div class="revenbook-drawer-shop vue_flex">
                        <!-- <img src="../../../../../assets/yimou/1760684116987.jpg" alt="" /> -->
                        <div class="vue_flex vue_column vue_flex_around">
                            <p class="vue-font-PingFang-500">
                                {{ nowItem.goodsname }}
                            </p>
                            <span class="vue-font-PingFang-500 color_35">商品ID:{{ nowItem.goodsid }}</span>
                        </div>
                    </div>
                    <div class="billing-boxs vue_flex vue_flex_between">
                        <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                            运营责权人
                        </p>
                        <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                            开始时间
                        </p>
                        <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                            截止时间
                        </p>
                        <p class="vue-font-PingFang-400 color_35 font18 line_height_18">
                            操作
                        </p>
                    </div>
                    <div class="billing-boxs-scoll">
                        <div class="billing-boxs-data vue_flex vue_flex_between vue_align_center"
                            v-for="(item, billingIndex) in billingList" :key="billingIndex">
                            <p class="vue-font-PingFang-500 color_35 font18">
                                {{ item.nickname }}
                            </p>
                            <ul class="vue_flex vue_flex_around">
                                <li class="vue_flex vue_align_center">
                                    <p class="vue-font-PingFang-500 font18 color_35">
                                        {{ timestampToTime(item.starttime, "YMD") }}
                                    </p>
                                    <img src="../../../../../assets/yimou/rl.png" alt="" />
                                </li>
                            </ul>
                            <ul class="vue_flex vue_flex_around">
                                <li class="vue_flex vue_align_center">
                                    <p class="vue-font-PingFang-500 font18 color_35">
                                        {{
                                            item.endtime == 0
                                                ? "-"
                                                : timestampToTime(item.endtime, "YMD")
                                        }}
                                    </p>
                                    <el-date-picker @change="seleTime(item)" v-model="item.endtime" type="datetime"
                                        value-format="timestamp" placeholder="选择日期时间">
                                    </el-date-picker>
                                    <img src="../../../../../assets/yimou/rl.png" alt="" />
                                </li>
                            </ul>
                            <div class="vue_flex vue_flex_around" @click="delLogs(item)">
                                <img src="../../../../../assets/yimou/sc.png" alt="" />
                            </div>
                        </div>
                    </div>
                    <ul class="revenbook-drawer-ul vue_flex vue_flex_end">
                        <div class="revenbook-drawer-ul-but vue-font-PingFang-500 color_255 h">
                            确定
                        </div>
                    </ul>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import Pagination from "@/components/Pagination"; // secondary package based on el-pagination
import { windowFun } from "@/utils/utils";
import DonMessage from "@/utils/message";
import Cookies from "js-cookie";
export default {
    components: { Pagination },
    data() {
        return {
            dpList: [],
            userlist: [],
            innerWidth: 0,
            innerHeight: 0,
            headercellstyle: {
                backgroundColor: "rgba(245, 247, 250, 1)",
                color: "rgba(51, 3, 0, 1)",
            },

            total: 0,
            listQuery: {
                page: 1,
                limit: 10,
            },

            searchValue: "",
            dataList: [
                {
                    shopid: "5465476576578",
                    shopname:
                        "zhengfly户外露营加厚野餐垫 公园防潮垫便携式草地地垫可 折叠地席",
                    channel: "淘宝",
                    shop: "zhengfly户外",
                    operation: "",
                },
                {
                    shopid: "5465476576578",
                    shopname:
                        "zhengfly户外露营加厚野餐垫 公园防潮垫便携式草地地垫可 折叠地席",
                    channel: "淘宝",
                    shop: "zhengfly户外",
                    operation: "",
                },
                {
                    shopid: "5465476576578",
                    shopname:
                        "zhengfly户外露营加厚野餐垫 公园防潮垫便携式草地地垫可 折叠地席",
                    channel: "淘宝",
                    shop: "zhengfly户外",
                    operation: "",
                },
            ],

            options: [
                { value: "选项1", label: "黄金糕" },
                { value: "选项2", label: "双皮奶" },
                { value: "选项3", label: "蚵仔煎" },
                { value: "选项4", label: "龙须面" },
                { value: "选项5", label: "北京烤鸭" },
            ],

            input: "",

            strokeDrawer: false,
            tempObj: {
                radio: "",
                onesubject: "",
                subject: "",
                timeradio: "",
                cost: "",
                price: "",
                priceradio: "",
                incomeradio: "",
                remarks: "",
                shopradio: "",
                sterplate: false,
            },
            billingList: [],
            nowItem: {},
            loglistQuery: {
                page: 1,
                limit: 10,
                goodsid: "",
            },
        };
    },

    created() {
        this.innerWidth = windowFun().innerWidth;
        this.innerHeight = windowFun().innerHeight;
        this.getdpListFun();
        this.getUserList();
        this.getListFun();
    },

    methods: {
        async seleTime(item) {
            const res = await this.$http.get(this.$urls.addendzequan, {
                id: item.id,
                endtime: item.endtime / 1000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.getLogs();
        },
        timestampToTime(timestamp, type) {
            var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            var Y = date.getFullYear() + "-";
            var M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth() + 1) + "-";
            var D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var h =
                date.getHours() < 10
                    ? "0" + date.getHours() + ":"
                    : date.getHours() + ":";
            var m =
                date.getMinutes() < 10
                    ? "0" + date.getMinutes() + ":"
                    : date.getMinutes() + ":";
            var s =
                date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
            if (type == "YMD") {
                return Y + M + D;
            }
            return Y + M + D + " " + h + m + s;
        },
        async delLogs(item) {
            this.$alert("是否确定要删除", "提示", {
                confirmButtonText: "确定",
                callback: async (action) => {
                    const res = await this.$http.get(this.$urls.delzequan, {
                        id: item.id,
                    });
                    if (res.errcode != 0) return DonMessage.error(res.errmsg);
                    this.getLogs();
                },
            });
        },
        async seleUser(item) {
            let params = {
                goodsid: item.goodsid,
                zquid: item.zqname,
            };
            const res = await this.$http.get(this.$urls.addzequan, params);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.getListFun();
        },
        async getListFun() {
            const res = await this.$http.get(this.$urls.getgoodslist, this.listQuery);
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dataList = res.list;
            this.total = res.count;
        },
        async getUserList() {
            const res = await this.$http.get(this.$urls.getuserlist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.userlist = res.list;
        },
        // 店铺列表
        async getdpListFun() {
            const res = await this.$http.get(this.$urls.getshoplist, {
                page: 1,
                limit: 10000,
            });
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.dpList = res.list;
        },
        async getLogs() {
            const res = await this.$http.get(
                this.$urls.getzequanlist,
                this.loglistQuery
            );
            if (res.errcode != 0) return DonMessage.error(res.errmsg);
            this.billingList = res.list;
        },
        getHetongListFun() { },
        eventClick(row) {
            this.nowItem = row;
            this.loglistQuery.goodsid = row.goodsid;
            this.getLogs();
            this.strokeDrawer = true;
        },
    },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__icon {
    display: none;
}

.plateorder {
    padding: 22px;
}

.plateorder-tabs {
    background: rgba(245, 245, 245, 1);
    border-radius: 10px;
    padding: 9px 18px 8px 47px;

    .plateorder-tabs-input {
        .shaixuan_item {
            width: 350px;
            height: 54px;
            background: #ffffff;
            border-radius: 10px;
            padding: 0 20px;
            margin-right: 22px;

            .shaixuan_item_con {
                p {
                    font-size: 18px;
                }

                .shaixuan_item_arr {
                    width: 13px;
                    height: 8px;
                    margin-left: 10px;
                }

                .shaixuan_item_icon {
                    width: 29px;
                    height: 24px;
                    margin-right: 10px;
                }
            }
        }

        .top_bar_inp {
            width: 372px;
            height: 54px;
            background: rgba(255, 255, 255, 1);
            border-radius: 10px;
            margin-right: 32px;
            padding: 0 11px;

            .top_bar_inp_img1 {
                width: 24px;
                height: 24px;
                margin-right: 12px;
            }

            .top_bar_inp_inp {
                width: 282px;
                font-size: 17px;
                line-height: 17px;
            }
        }
    }

    .plateorder-tabs-piye-but {
        width: 138px;
        height: 55px;
        line-height: 53px;
        text-align: center;
        background: #ffffff;
        border-radius: 10px;
        border: 1px solid rgba(153, 153, 153, 1);
        font-size: 20px;
        margin-right: 26px;
    }

    .plateorder-tabs-input-but {
        width: 131px;
        height: 54px;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 20px;
        line-height: 54px;
        text-align: center;
    }
}

.import-mask {
    width: 100%;
    border-radius: 15px;
    background-image: url("../../../../../assets/yimou/tb.png");
    background-size: 100% 51px;
    background-repeat: no-repeat;
    padding-bottom: 40px;

    .import-mask-title {
        width: 100%;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 18px;

        img {
            width: 13px;
            height: 13px;
            top: 21px;
            right: 20px;
        }
    }

    .import-mask-boxs {
        width: 650px;
        margin-top: 40px;

        .import-mask-boxs-inp {
            width: 100%;
            background: rgba(245, 245, 245, 1);
            border-radius: 10px;
            padding: 11px 22px;
            margin-bottom: 19px;

            ul {
                li:nth-of-type(1) {
                    width: 185px;
                    font-size: 18px;
                    line-height: 18px;

                    span {
                        color: rgba(255, 0, 0, 1);
                    }
                }
            }
        }

        .import-mask-boxs-inp .el-input /deep/.el-input__inner {
            border: none !important;
            background: none !important;
            font-size: 18px;
        }

        .import-mask-boxs-inp .el-textarea /deep/.el-textarea__inner {
            border: none !important;
            background: none !important;
            font-size: 18px;
        }

        .import-mask-boxs-upload {
            width: 100%;
            height: 168px;
            margin: 10px 0px 34px;
            background-image: url("../../../../../assets/yimou/hsk.png");

            img {
                width: 35px;
                height: 31px;
                margin-top: 39px;
            }

            .upload-title {
                font-size: 16px;
                line-height: 16px;
                margin: 16px 0px 13px;

                span:nth-of-type(2) {
                    color: rgba(20, 75, 201, 1);
                }
            }

            .upload-content {
                font-size: 14px;
                line-height: 14px;
            }
        }

        .import-mask-ul-boxs {
            width: 24vw;
        }
    }

    .import-mask-but {
        width: 266px;
        height: 47px;
        line-height: 47px;
        text-align: center;
        background: rgba(25, 92, 248, 1);
        border-radius: 10px;
        font-size: 17px;
    }
}

.plateorder-type {
    margin: 23px 0px;

    div {
        width: 155px;
        height: 44px;
        line-height: 44px;
        text-align: center;
        border-radius: 10px;
        margin-right: 14px;
    }

    .active {
        color: rgba(255, 255, 255, 1);
        background: rgba(25, 92, 248, 1);
    }

    .activenot {
        color: rgba(35, 35, 35, 1);
        background: rgba(245, 245, 245, 1);
    }
}

.import-mask-boxs-inp .el-input /deep/.el-input__inner {
    border: none !important;
    font-size: 18px;
}

.revenbook-drawer .el-input /deep/.el-input__inner {
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select {
    width: 100% !important;
}

.el-select /deep/.el-input__inner {
    width: 100%;
    border: none !important;
    background: none !important;
    font-size: 18px;
}

.el-select /deep/.el-select__caret {
    color: #000000 !important;
}

.upload-demo /deep/.el-upload-dragger {
    background: none !important;
    border: none !important;
    border-radius: 0px !important;
    width: 640px !important;
    height: 168px;
}

.statusact {
    width: 13px;
    height: 13px;
    background: rgba(48, 255, 0, 1);
    border-radius: 50%;
    margin-right: 12px;
}

.statusactnot {
    width: 13px;
    height: 13px;
    background: red;
    border-radius: 50%;
    margin-right: 12px;
}

.reset-btn {
    font-size: 30px;
}

.revenbook-drawer {
    padding: 0px 25px;

    .revenbook-drawer-shop {
        img {
            width: 80px;
            height: 80px;
            background: #000000;
            border-radius: 10px;
            margin-right: 20px;
        }

        p {
            color: rgba(30, 91, 209, 1);
            font-size: 22px;
            line-height: 22px;
        }

        span {
            font-size: 18px;
            line-height: 18px;
        }
    }

    .billing-boxs {
        margin: 29px 0px 12px;
        padding: 23px 0px 19px;
        background: rgba(244, 245, 249, 1);
        border-radius: 10px;

        p {
            width: 18%;
            text-align: center;
        }
    }

    .billing-boxs-scoll {
        height: 58vh;
        overflow-y: scroll;
        scrollbar-width: none;
        /* Firefox */
        -ms-overflow-style: none;
    }

    .billing-boxs-data {
        margin-bottom: 17px;

        p {
            width: 23%;
            height: 46px;
            text-align: center;
        }

        ul {
            height: 46px;

            li {
                width: 196px;
                background: #f5f5f5;
                border-radius: 10px;
                padding: 0px 10px;

                p {
                    width: 117px;
                    line-height: 46px;
                }

                img {
                    width: 17px;
                    height: 20px;
                }
            }
        }

        div {
            width: 18%;

            img {
                width: 17px;
                height: 20px;
            }
        }
    }

    .revenbook-drawer-ul {
        margin-top: 27px;

        .revenbook-drawer-ul-but {
            width: 131px;
            height: 54px;
            line-height: 54px;
            text-align: center;
            background: rgba(25, 92, 248, 1);
            border-radius: 10px;
        }
    }
}

.costduty-operation {
    width: 216px;
    background: #f3f3f3;
    border-radius: 10px;

    .el-select /deep/.el-input__inner {
        font-size: 12px !important;
    }
}

.shaixuan_item {
    .el-input /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }

    .el-input /deep/.el-input__prefix {
        display: none !important;
    }

    .el-select /deep/.el-input__inner {
        border: none !important;
        text-align: right;
        font-size: 18px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/level1/goodsmanage/costduty/index.vue